import { render, staticRenderFns } from "./countryCurrency.vue?vue&type=template&id=5dc8839a"
import script from "./countryCurrency.vue?vue&type=script&lang=js"
export * from "./countryCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports